export interface AccountLookup {
  id?: number;
  emailAddress?: string;
  firstName?: string;
  lastName?: string;
  phoneNumber?: string;
  accountSourceId?: number;
  isRegistered?: boolean;
}
